import { useState } from "react"
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { Bound } from "lib/@components/binding/Bound"
import { Repeat } from "lib/@components/repeat"
import { CopAuthorityCheckbox } from "./cop-authority-checkbox"

export const AUTHORITY_OPTIONS = [
    { value: "government", label: "Government", icon: "mdi:bank", color: "success.dark" },
    { value: "standards-body", label: "Standards Body", icon: "mdi:certificate", color: "info.dark" },
    { value: "trade-association", label: "Trade Assoc.", icon: "mdi:account-group", color: "#c2410c" },
    { value: "manufacturer", label: "Manufacturer", icon: "mdi:factory", color: "text.primary" },
    { value: "user-supplied", label: "User Supplied", icon: "mdi:account-edit", color: "text.secondary" },
]

const ALL_VALUES = new Set(AUTHORITY_OPTIONS.map((o) => o.value))

export function CopScanAuthorityDialog({ ok, cancel }) {
    const [selected, setSelected] = useState(ALL_VALUES)

    return (
        <>
            <DialogTitle>Scan All Schedules</DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    Choose which document authority types to include in the scan.
                </Typography>
                <Bound selected={selected} setSelected={setSelected}>
                    <Repeat list={AUTHORITY_OPTIONS} item={<CopAuthorityCheckbox />} />
                </Bound>
            </DialogContent>
            <DialogActions>
                <Button onClick={cancel}>Cancel</Button>
                <Button
                    onClick={handleScan}
                    variant="contained"
                    disabled={selected.size === 0}
                    startIcon={<Iconify icon="mdi:magnify-scan" />}
                >
                    Scan
                </Button>
            </DialogActions>
        </>
    )

    function handleScan() {
        ok([...selected])
    }
}
